import {Component, Injectable, ViewChild} from '@angular/core';
import {IParticipant, IQuestionnaireOverviewItem, IQuestionnaireWorkflowItem, IWorkflow} from '@interfaces/interfaces';
import { Observable, of} from 'rxjs';
import { WorkflowItemDirective } from '../../../workflow/directives/workflow-item/workflow-item.directive';
import {WorkflowRestService} from '../../../services/rest/workflow-rest.service';
import {WorkflowItemData, WorkflowItemStatus} from '@api/projects/interfaces';
import {WorkflowCategory, WorkflowService} from '../../../workflow/services/workflow.service';
import {provideMockStore} from '@ngrx/store/testing';
import * as workflowStub from '../../../workflow/workflow-stub.json';
import * as menuDataStub from '../../../workflow/components/sidebar/projektsidebar.component.spec.json';
import { SessionItemData } from '../../../workflow/services/session-item-data';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';

@Injectable()
class WorkflowRestServiceStub implements Partial<WorkflowRestService> {
	value: WorkflowItemData = {pid: 'pid', itemid: 'item', data: {}};

	getWorkflowItemStatus$(): Observable<WorkflowItemData> {
		return of(this.value);
	}

	updateStatus$(projectID: string, pid: string, itemId: string, data: Partial<WorkflowItemData>): Observable<WorkflowItemData> {
		this.value = {...this.value, data: data.data};
		return of(this.value);
	}
}

@Injectable()
class workflowServiceStub implements Partial<WorkflowService> {
	get workflow() { return workflowStub as IWorkflow; }
	get workflow$() {return of(this.workflow) as Observable<IWorkflow>; }
	get workflowCategories() : WorkflowCategory[] { return [].concat(menuDataStub); }
}

const initialState = {
	appstatesettings: {
		activeProjectID: 'proj',
		activeParticipantID: 'pid',
	},
	settings : {

	},
};

@Component({
	selector: 'app-overview-tile-showcase',
	templateUrl: './overview-tile-showcase.component.html',
	styleUrls: ['../../../workflow/components/questionnaire/overview/questionnaire-overview.component.scss'],
	providers: [
		{ provide: WorkflowRestService, useClass: WorkflowRestServiceStub },
		{ provide: WorkflowService, useClass: workflowServiceStub },
		provideMockStore({ initialState }),
	],
})

export class OverviewTileShowcaseComponent {
	isConfirmDialogVisible = false;
	allValid: boolean;
	viewMode: string;
	data: IQuestionnaireOverviewItem;
	workflowItem: IQuestionnaireWorkflowItem;
	groupStatus: string[];
	participant: IParticipant;
	workflowItemStatus: WorkflowItemStatus;
	workflowCategories: WorkflowCategory[];

	@ViewChild(WorkflowItemDirective)
	public directive: WorkflowItemDirective;

	item: SessionItemData;

	public startWorkflowSplitbutton: SplitButtonElement = {
		title: 'workflow.start',
		type: 'primary',
	};
	public continueWorkflowSplitbutton: SplitButtonElement = {
		title: 'workflow.continue',
		type: 'primary',
	};
	public finishWorkflowSplitbutton: SplitButtonElement = {
		title: 'workflow.end',
		type: 'primary',
		icon: 'check',
		callback: () => this.showModalToFinishWorkflow(),
	};
	public cancelWorkflowSplitbutton: SplitButtonElement = {
		title: 'workflow.quitOverview',
		type: 'default',
		icon: 'X',
	};
	public overviewWorkflowSplitbutton: SplitButtonElement = {
		title: 'workflow.quitWizard',
		type: 'default',
		icon: 'X',
	};

	constructor() {
		this.data = {
			key: 'test',
			label: 'Testwerte'
		};

		this.workflowItem = {
			type: 'Questionnaire',
			id: 'Test-Showcase',
			name: 'Showcase Workflow',
			category: 'Showcase-Category',
			description: 'Dies ist ein Workflowschritt zu Demonstrationszwecken',
			groups: [{
				title: 'Showcase',
				groupOverview: [this.data],
				items: null,
			}],
			showOverview: true,
		};

		this.workflowCategories = [
			{
				name: 'Showcase Workflow',
				items: [this.workflowItem]
			}
		];

		this.workflowItemStatus = {
			completed: true,
			started: false
		};

		this.participant = {
			id: 'Max Mustermann',
			data: null
		};

		this.groupStatus = ['finished'];

		this.viewMode = 'compact';
	}

	showModalToFinishWorkflow(): void {
		this.isConfirmDialogVisible = true;
	}

	handleOkToFinishWorkflow(): void {
		this.isConfirmDialogVisible = false;
	}

	handleCancelToDismissFinishWorkflow(): void {
		this.isConfirmDialogVisible = false;
	}
}
